import { render } from "./DettaglioRapportino.vue?vue&type=template&id=2d7641e2&scoped=true"
import script from "./DettaglioRapportino.vue?vue&type=script&lang=js"
export * from "./DettaglioRapportino.vue?vue&type=script&lang=js"

import "./DettaglioRapportino.vue?vue&type=style&index=0&id=2d7641e2&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_jecko_1768814729495645082/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7641e2"]])

export default __exports__